/*
 * Module for the correspondence Index view
*/
rs.module("content/communications/correspondence/index",

    [],

    function () {
        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrl) {

            // Unpack Js Selectors
            var filterSelect = $.js(jsSelectors.filterSelect);
            var correspondenceList = $.js(jsSelectors.correspondenceList);
            var listSkeleton = $.js(jsSelectors.listSkeleton);

            // Update the list based on selected filter
            filterSelect.change(function () {

                listSkeleton.show();
                correspondenceList.hide();

                $.get(
                    backendUrl,
                    {
                        filterSelection: $(this).val()
                    })
                    .done(function (html) {
                        correspondenceList.html(html);
                    })
                    .always(function () {
                        listSkeleton.hide();
                        correspondenceList.show();
                    });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);